import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import DislikeOutlinedSvg from "@ant-design/icons-svg/es/asn/DislikeOutlined";
import AntdIcon from "../components/AntdIcon";
var DislikeOutlined = function DislikeOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: DislikeOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  DislikeOutlined.displayName = 'DislikeOutlined';
}
export default /*#__PURE__*/React.forwardRef(DislikeOutlined);